/**
 * PestConfigScreen — platform gate for /scouting/config (RECONCILIATION §6.1,
 * Desktop Spec §E). Both layouts are first-class — NO "use another device"
 * notice (unlike recording). Handheld → compact editor; otherwise → the desktop
 * master–detail. Evaluated once per mount (mirrors FieldScoutModePage).
 */
import React from 'react';
import { isCompactDevice } from '../../utils/platform';
import PestConfigPage from './PestConfigPage';
import PestConfigMobilePage from './PestConfigMobilePage';

const PestConfigScreen: React.FC = () =>
  isCompactDevice() ? <PestConfigMobilePage /> : <PestConfigPage />;

export default PestConfigScreen;
